module.exports = __webpack_public_path__ + "img/logo.b4d34f5b.png";